module.exports = __webpack_public_path__ + "static/media/content_3.490d6f48.png";